/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRolePresetDto } from '../../models/backend-role-preset-dto';
import { BackendRolePresetCreateRequestDto } from '../../models/backend-role-preset-create-request-dto';

export interface AccessRolePresetsCreate$Params {
  body: BackendRolePresetCreateRequestDto;
}

export function accessRolePresetsCreate(
  http: HttpClient,
  rootUrl: string,
  params: AccessRolePresetsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendRolePresetDto>> {
  const rb = new RequestBuilder(rootUrl, accessRolePresetsCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendRolePresetDto>;
    }),
  );
}

accessRolePresetsCreate.PATH = '/api/access/role-presets/';
